module.exports = __webpack_public_path__ + "img/ipgone_page1.655fadbb.png";